import React, { useState } from 'react';
import axios from 'axios';
import { setUserSession } from './Utils/Common';
import './assets/materialize.min.css';

function Login(props) {
  const [loading, setLoading] = useState(false);
  const identifier = useFormInput('');
  const password_digest = useFormInput('');
  const [error, setError] = useState(null);

  // handle button click of login form
  const handleLogin = () => {
    setError(null);
    setLoading(true);
    axios.post('https://contest.seemitra.id/api/v1/users/login/', { identifier: identifier.value, password_digest: password_digest.value }).then(response => {
      setLoading(false);
      setUserSession(response.data.token.token, response.data.username);
      props.history.push('/dashboard');
    }).catch(error => {
      setLoading(false);
      if (error.response === 400) setError(error.response.data.message);
      else setError("Username atau Password Salah!");
    });
  }

  return (
    <div className="container">
      <h4>Login</h4><br /><br />
      <div>
        Username<br />
        <input type="text" {...identifier} autoComplete="new-password" />
      </div>
      <div style={{ marginTop: 10 }}>
        Password<br />
        <input type="password" {...password_digest} autoComplete="new-password" />
      </div>
      {error && <><small style={{ color: 'red' }}>{error}</small><br /></>}<br />
      <br />
      <button class="btn waves-effect waves-light" type="submit" name="action" value={loading ? 'Loading...' : 'Login'} onClick={handleLogin} disabled={loading}>Login</button>
    </div>
  );
}

const useFormInput = initialValue => {
  const [value, setValue] = useState(initialValue);

  const handleChange = e => {
    setValue(e.target.value);
  }
  return {
    value,
    onChange: handleChange
  }
}

export default Login;